import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InstagramIcon from "../images/Instagram_Glyph_Black.png";
import FacebookIcon from "../images/Facebook_Logo_Secondary.png";

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  padding-top: 10px;
  border-radius: 8px;
  border-top: 1px solid rgb(192 196 202);
  @media (max-width: 700px) {
    display: block;
  }
`;

const CompanyInfo = styled.div`
  align-content: center;
`;

const CompanySocialInfo = styled(CompanyInfo)`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 700px) {
    justify-content: center;
  }
`;

const Text = styled.p`
  font-size: 10px;
  margin: 5px;
  @media (max-width: 700px) {
    text-align: center;
    display: block;
  }
`;

const CompanyName = styled(Text)`
  color: rgb(197 59 108);
  font-size: 14px;
`;
const CompanySlogan = styled(Text)`
  font-size: 12px;
`;

const ContactInfoText = styled(Text)`
  margin-left: 10px;
`;

const CompanySocial = styled.img`
  margin: 0 5px 5px 0;
  width: 15px;
`;

const StyledFacebookIcon = styled(CompanySocial)`
  background-color: black;
  border-radius: 1px;
`;

const CopyRight = styled(Text)`
  margin-top: 20px;
  text-align: center;
  font-size: 8px;
`;

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <CompanyInfo>
          <CompanyName>{t("company.name")}</CompanyName>
          <CompanySlogan>{t("company.slogan")}</CompanySlogan>
        </CompanyInfo>
        <CompanyInfo>
          <ContactInfo>
            <PhoneIcon sx={{ fontSize: 15, color: "rgb(197 59 108)" }} />
            <ContactInfoText>(619) 754-9500</ContactInfoText>
          </ContactInfo>
          <ContactInfo>
            <EmailIcon sx={{ fontSize: 15, color: "rgb(197 59 108)" }} />
            <ContactInfoText>{t("company.email")}</ContactInfoText>
          </ContactInfo>
          <ContactInfo>
            <LocationOnIcon sx={{ fontSize: 15, color: "rgb(197 59 108)" }} />
            <ContactInfoText>{t("company.address")}</ContactInfoText>
          </ContactInfo>
        </CompanyInfo>
        <CompanyInfo>
          <Text>{t("company.followOnSocial")}</Text>
          <CompanySocialInfo>
            <CompanySocial src={InstagramIcon} />
            <StyledFacebookIcon src={FacebookIcon} />
          </CompanySocialInfo>
        </CompanyInfo>
      </Container>
      <CopyRight>©{t("company.rightReserved")}</CopyRight>
    </>
  );
};
export default Footer;
